import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage, ForgotPasswordPage } from "@/pages/Auth";
import Plan from "@/pages/Plan";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";
import Credit from "@/pages/Credit";
import AdminCredit from "@/pages/AdminCredit";
import Dashboard from "@/pages/Dashboard";
import Bots from "@/pages/Bots";
import Deposit from "@/pages/Deposit";
import Withdraw from "@/pages/Withdraw";
import TeamTree from "@/pages/TeamTree";
import Referrals from "@/pages/Referrals";
import Transactions from "@/pages/Transactions";
import KYC from "@/pages/KYC";
import Profile from "@/pages/Profile";
import Trades from "@/pages/Trades";
import Leaderboard from "@/pages/Leaderboard";
import Impersonate from "@/pages/Impersonate";
import DownloadApp from "@/pages/DownloadApp";
import Staking from "@/pages/Staking";
import Shareholder from "@/pages/Shareholder";
import { AdminStaking, AdminShareholder } from "@/pages/AdminStakingShareholder";
import AdminSupport from "@/pages/AdminSupport";
import Support from "@/pages/Support";
import { AdminOverview, AdminUsers, AdminDeposits, AdminWithdrawals, AdminKyc, AdminBots, AdminAnnouncements, AdminUserDetail, AdminTransactions, AdminConfig } from "@/pages/Admin";
import AdminTourFunds from "@/pages/AdminTourFunds";
import PWAInstallBanner from "@/components/PWAInstallBanner";
import NBToken from "@/pages/NBToken";
import AdminNBToken from "@/pages/AdminNBToken";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{style: {background: "#0F1626", color: "#F8FAFC", border: "1px solid rgba(255,255,255,0.1)"}}}/>
        <PWAInstallBanner/>
        <Routes>
          <Route path="/" element={<Landing/>}/>
          <Route path="/plan" element={<Plan/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/privacy" element={<Privacy/>}/>
          <Route path="/terms" element={<Terms/>}/>
          <Route path="/delete-account" element={<DeleteAccount/>}/>
          <Route path="/credit" element={<Credit/>}/>
          <Route path="/login" element={<LoginPage/>}/>
          <Route path="/register" element={<RegisterPage/>}/>
          <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>

          <Route path="/dashboard" element={<Dashboard/>}/>
          <Route path="/bots" element={<Bots/>}/>
          <Route path="/staking" element={<Staking/>}/>
          <Route path="/shareholder" element={<Shareholder/>}/>
          <Route path="/trades" element={<Trades/>}/>
          <Route path="/deposit" element={<Deposit/>}/>
          <Route path="/withdraw" element={<Withdraw/>}/>
          <Route path="/team" element={<TeamTree/>}/>
          <Route path="/referrals" element={<Referrals/>}/>
          <Route path="/transactions" element={<Transactions/>}/>
          <Route path="/kyc" element={<KYC/>}/>
          <Route path="/profile" element={<Profile/>}/>
          <Route path="/leaderboard" element={<Leaderboard/>}/>
          <Route path="/download-app" element={<DownloadApp/>}/>
          <Route path="/nb-token" element={<NBToken/>}/>
          <Route path="/support" element={<Support/>}/>
          <Route path="/impersonate" element={<Impersonate/>}/>
          <Route path="/impersonate/loading" element={<Impersonate/>}/>

          <Route path="/admin" element={<AdminOverview/>}/>
          <Route path="/admin/users" element={<AdminUsers/>}/>
          <Route path="/admin/users/:id" element={<AdminUserDetail/>}/>
          <Route path="/admin/deposits" element={<AdminDeposits/>}/>
          <Route path="/admin/withdrawals" element={<AdminWithdrawals/>}/>
          <Route path="/admin/credit" element={<AdminCredit/>}/>
          <Route path="/admin/kyc" element={<AdminKyc/>}/>
          <Route path="/admin/bots" element={<AdminBots/>}/>
          <Route path="/admin/staking" element={<AdminStaking/>}/>
          <Route path="/admin/shareholder" element={<AdminShareholder/>}/>
          <Route path="/admin/support" element={<AdminSupport/>}/>
          <Route path="/admin/transactions" element={<AdminTransactions/>}/>
          <Route path="/admin/config" element={<AdminConfig/>}/>
          <Route path="/admin/announcements" element={<AdminAnnouncements/>}/>
          <Route path="/admin/tour-funds" element={<AdminTourFunds/>}/>
          <Route path="/admin/nb-token" element={<AdminNBToken/>}/>

          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
